<div class="flex justify-between status-bar" [class.fade-in]="shouldFadeIn()" [style.background-color]="statusMap[connectionQuality()]?.color">
  <div class="flex ml-2">
    <div class="flex gap-1 items-center text-white">
      @if (userHasAccessToMoreThanOneTenant() && selectedTenant(); as tenant) {
        <a routerLink="/app/user/switch-tenant" class="hidden lg:block text-inherit no-underline" aria-label="Switch tenant">
          <mat-icon class="inline-baseline-icon">domain</mat-icon>
          {{ tenant.name }}
        </a>
        <a routerLink="/app/user/switch-tenant" class="block lg:hidden text-inherit no-underline" aria-label="Switch tenant">
          <mat-icon>domain</mat-icon>
        </a>
        <div class="hidden lg:block opacity-60">|</div>
      }
      <div class="hidden lg:block">
        Connection: {{ connectionQuality() }}
      </div>
      <div class="block lg:hidden">
        <mat-icon>{{statusMap[connectionQuality()]?.iconName}}</mat-icon>
      </div>
    </div>
  </div>
  <div class="flex mr-2">
    <div class="flex gap-1 items-center text-white">
      @if (stateViewerPreviouslyOpened$ | async) {
        <button type="button" *appIfHasPrivileges="['UI_VIEW_TOOLS_STATE_VIEWER']" mat-icon-button (click)="showStateViewerDialog()">
          <mat-icon>account_tree</mat-icon>
        </button>
      }
      <div class="flex gap-1 items-center cursor-pointer cco-global-date-range-filter-icon" (click)="onDateRangeClick()">
        <div class="hidden lg:block">Showing</div>
        <div>{{ dateRange() | lxDateRange:'all data' }}</div>
        <mat-icon class="text-lg">date_range</mat-icon>
      </div>
    </div>
  </div>
</div>
